import postNewUpload from './postNewUpload';

const getUploadObjectId = (apiUrl, flightPayload) =>
  postNewUpload(apiUrl, flightPayload);

export default getUploadObjectId;
